
namespace Matrix.Indexation {
    export class PriceTypeColumns {
        static columnsKey = 'Indexation.PriceType';
    }
}